import { defineMessages } from '@redbubble/next/intl';

export const messages = defineMessages({
  costSummaryText: {
    defaultMessage: 'Cost Summary',
  },
  freeOrderMessageTitle: {
    defaultMessage: 'Hooray! Your order is free',
  },
  freeOrderMessageSubtitle: {
    defaultMessage: 'No payment required.',
  },
  itemsTitle: {
    defaultMessage:
      '{lineItemsCount} {lineItemsCount, plural, one {item} other {items}}',
  },
  standardShipping: {
    defaultMessage: 'Standard shipping',
  },
  standardShippingEstimated: {
    defaultMessage: 'Standard shipping (estimated)',
  },
  expressShipping: {
    defaultMessage: 'Express shipping',
  },
  expressShippingEstimated: {
    defaultMessage: 'Express shipping (estimated)',
  },
  flatRateShipping: {
    defaultMessage: 'Flat Shipping Rate',
  },
  previously: {
    defaultMessage: 'Previously was',
  },
  now: {
    defaultMessage: 'Now is',
  },
  giftcardCoupon: {
    defaultMessage: 'Gift Card',
  },
  taxTitle: {
    defaultMessage: 'Tax',
  },
  amountCoupon: {
    defaultMessage: 'Discount',
  },
  totalTitle: {
    defaultMessage: 'Total',
  },
  subtotalTitle: {
    defaultMessage: 'Subtotal',
  },
  includedTax: {
    defaultMessage: 'Includes {taxAmount} in taxes',
  },
  taxAndShippingAtCheckout: {
    defaultMessage: 'Tax and shipping will be calculated at checkout',
  },
});
